import {Link} from "react-router-dom";
import { formatFullDate } from "../Assets/StaticContents/helpers";
import { RichText } from 'prismic-reactjs';

const BlogCard = (blog) => {
    const blogObj = blog.blog || {}
    const blogData = blog.blog?.data || {}
    return (
        <Link to={`/blogs/${blogObj.id}`} className="w-full" title={blogData.title.text}>
            <div className="overflow-hidden rounded-lg bg-white transition-shadow duration-300 ease-in-out">
                <div className="col-span-3 row-span-4">
                    <div>
                        <img
                            loading="lazy"
                            src={blogData.image.url}
                            alt="Placeholder"
                            className="rounded-lg object-cover h-48 w-full shadow"
                        />
                    </div>
                </div>

                <div className="col-span-3 row-span-1 py-3">
                    <div className="text-lg capitalize text-gray-700 py-1">
                        {RichText.render(blogData.title)}
                    </div>
                    <p className="space-x-2 text-sm text-gray-400">
                        <span>{ formatFullDate(blogObj.first_publication_date) }</span>
                    </p>
                </div>
            </div>
        </Link>
    )
}

export default BlogCard